module.exports = __webpack_public_path__ + "static/media/reformas.410a09aa.png";